
import { Stack, Tooltip, Typography } from "@mui/material";
import { GridColDef, GridRenderCellParams } from "@mui/x-data-grid-premium";
import moment from "moment";
import { DownloadDoc } from "../../components";
import FileSize from "../../components/fileSize";
import { WIPIcon } from "../../images/svg/WIPIcon";
import { PublishedIcon } from "../../images/svg/publishedIcon";
import { convertSize, TAG_CANONICAL_NAMES } from "../../utils";

export const giveMeLocationAndDocumentTags = (tags_info: any) => {
    let location_tags: any = null;
    let document_tags: any = null;
    let document_priority: any = null;

    tags_info?.forEach((_: any) => {
        if (_.tag_group_canonical_name === TAG_CANONICAL_NAMES.doc_type) {
            document_tags = { value: _.tag_id, label: _.tag_name, ..._ }
        }
        if (_.tag_group_canonical_name === TAG_CANONICAL_NAMES.folders) {
            location_tags = { value: _.tag_id, label: _.tag_name, ..._ }
        }
        if (_.tag_group_canonical_name === TAG_CANONICAL_NAMES.doc_priority) {
            document_priority = { value: _.tag_id, label: _.tag_name, ..._ }
        }
    })
    return { location_tags, document_tags, document_priority };
}

export const DashboardTableColumn = ():GridColDef[] => ([
    {
        field: 'sequence_id', headerName: 'Doc ID', width: 120, renderCell: (params: GridRenderCellParams) => {
            return <Tooltip title={params.row?.sequence_id}><Typography variant="body2" sx={{ width: "100%", overflow: "hidden", textOverflow: "ellipsis" }}>{params.row?.sequence_id}</Typography></Tooltip>
        }
    },
    { field: 'version', headerName: 'Revision', width: 90 },
    {
        field: 'actions',
        // type: 'actions',
        headerName: 'Actions',
        width: 150,
        cellClassName: 'actions',
        sortable: false,
        hideSortIcons: true,
        disableColumnMenu: true,
        resizable: false,
        renderCell: (params: any) => {
            const fileType = params.row?.file_name?.split('.')?.pop();
            return <Stack><DownloadDoc fileType={fileType ?? "Unknown"} preview={true} id={params.row._id} url={params.row.url} status={params.row.status} /></Stack>;
        }
    },
    {
        field: 'file_name', headerName: 'File Name', width: 200, renderCell: (params: GridRenderCellParams) => {
            return <Tooltip title={params.row?.file_name}><Typography variant="body2" sx={{ width: "100%", overflow: "hidden", textOverflow: "ellipsis" }}>{params.row?.file_name}</Typography></Tooltip>
        }
    },
    // {
    //     field: 'location_tags', headerName: 'Folder', width: 150,
    //     valueGetter: (value, row, column, apiRef) => giveMeLocationAndDocumentTags(row.tags_info).location_tags?.label,
    //     renderCell: (params: GridRenderCellParams) => {
    //         if (params.rowNode.type === 'group') {
    //             if (params.rowNode.groupingField === 'location_tags') {
    //                 return params.rowNode.groupingKey;
    //             }
    //             return '';
    //         }

    //         const location = giveMeLocationAndDocumentTags(params.row.tags_info).location_tags;

    //         return <Stack spacing={1} id={"tagsChip"} sx={{
    //             width: "100%",
    //             direction: "row",
    //         }}>
    //             <Chip sx={{ borderColor: location?.tag_group_color || '#3b82f6', backgroundColor: location?.tag_group_color || '#e5f6fd', color: `${hexToGrayscale(location?.tag_group_color || '#e5f6fd') > 150 ? "rgba(0, 0, 0, 0.87)" : "#FFFFFF"}` }} variant="outlined" size={"small"} label={`${location?.label}`} />
    //         </Stack>
    //     },
    //     renderHeader: () => (
    //         <Box display={"flex"} alignItems={"center"} gap={1}>
    //             <Typography variant="body2" fontWeight={"bold"}>{"Folder"}</Typography>
    //             <Folder htmlColor="#fde100" fontSize="medium" sx={{ verticalAlign: "bottom" }} />
    //         </Box>
    //     ),
    //     groupingValueGetter: (value, row, column, apiRef) => {
    //         return giveMeLocationAndDocumentTags(row.tags_info).location_tags?.label;
    //     },
    //     disableColumnMenu: true,
    //     sortable: false,
    // },
    // {
    //     field: 'document_type_tags', headerName: 'Document Type', width: 150,
    //     valueGetter: (value, row, column, apiRef) => giveMeLocationAndDocumentTags(row.tags_info).document_tags?.label,
    //     renderCell: (params: GridRenderCellParams) => {
    //         if (params.rowNode.type === 'group') {
    //             if (params.rowNode.groupingField === 'document_type_tags') {
    //                 return params.rowNode.groupingKey;
    //             }
    //             return '';
    //         }

    //         const document = giveMeLocationAndDocumentTags(params.row.tags_info).document_tags;

    //         return <Stack spacing={1} direction={"row"} id={"tagsChip"} sx={{
    //             width: "100%",
    //             direction: "row",
    //         }}>
    //             <Chip sx={{ borderColor: document?.tag_group_color || '#3b82f6', backgroundColor: document?.tag_group_color || '#e5f6fd', color: `${hexToGrayscale(document?.tag_group_color || '#e5f6fd') > 150 ? "rgba(0, 0, 0, 0.87)" : "#FFFFFF"}` }} variant="outlined" size={"small"} label={`${document?.label}`} />
    //         </Stack>
    //     },
    //     groupingValueGetter: (value, row, column, apiRef) => {
    //         return giveMeLocationAndDocumentTags(row.tags_info).document_tags?.label ?? "Grouping";
    //     },
    //     disableColumnMenu: true,
    //     sortable: false,
    // },
    // {
    //     field: 'document_priority', headerName: 'Document Priority', width: 250,
    //     valueGetter: (value, row, column, apiRef) => giveMeLocationAndDocumentTags(row.tags_info).document_priority?.label,
    //     renderCell: (params: GridRenderCellParams) => {
    //         if (params.rowNode.type === 'group') {
    //             if (params.rowNode.groupingField === 'document_priority') {
    //                 return params.rowNode.groupingKey;
    //             }
    //             return '';
    //         }

    //         const document = giveMeLocationAndDocumentTags(params.row.tags_info).document_priority;

    //         if (document) {
    //             return (
    //                 <Stack
    //                     spacing={1}
    //                     direction={"row"}
    //                     id={"tagsChip"}
    //                     sx={{
    //                         width: "100%",
    //                     }}>
    //                     <Chip sx={{ borderColor: document?.tag_group_color || '#3b82f6', backgroundColor: document?.tag_group_color || '#e5f6fd', color: `${hexToGrayscale(document?.tag_group_color || '#e5f6fd') > 150 ? "rgba(0, 0, 0, 0.87)" : "#FFFFFF"}` }} variant="outlined" size={"small"} label={`${document?.label}`} />
    //                 </Stack>
    //             );
    //         } else {
    //             return <></>
    //         }
    //     },
    //     groupingValueGetter: (value, row, column, apiRef) => {
    //         return giveMeLocationAndDocumentTags(row.tags_info).document_priority?.label ?? "Grouping";
    //     },
    //     disableColumnMenu: true,
    //     sortable: false,
    // },
    {
        field: 'released',
        headerName: 'Status',
        width: 90,
        renderCell: (params: GridRenderCellParams) => {
            return (
                (<Stack
                    sx={{
                        px: 3,
                        py: 2
                    }}>
                    {params?.row?.released && <Tooltip title="Published" children={<div><PublishedIcon /></div>} />}
                    {!params?.row?.released && <Tooltip title="Yet to publish" children={<div><WIPIcon /></div>} />}
                </Stack>)
            );
        }
    },
    {
        field: 'size', headerName: 'Size', width: 100, renderCell: (params: GridRenderCellParams) => {
            return <FileSize id={params.row._id} status={params.row.status} size={params.row?.size ?? 0} />
        },
        groupingValueGetter: (value, row, column, apiRef) => {
            return convertSize(row?.size ?? 0)
        },
    },
    { field: 'created_user', headerName: 'Uploaded By', width: 150 },
    {
        field: 'created_time', headerName: 'Uploaded Date', width: 200, renderCell: (params: GridRenderCellParams) => {
            return <Typography variant="body2" sx={{ width: "100%", overflow: "hidden", textOverflow: "ellipsis" }}>{moment(params.row.created_time).format('lll')}</Typography>
        }
    },
])